/**
 * The rider (delivery-as-a-service) reads off an order's event log and `deliveryBy`, plus the
 * two verified-items reads the card row shows. Uplifted 2026-09-15 for the shared `RiderRow`.
 * A leaf like `fulfillmentStatus.ts`.
 *
 * Sources: web `helper/myOrderHelpers` (mobile has the same five, minus `isRiderAssigned`,
 * which is web-only) and both apps' `helper/commonHelpers` for the two verified reads.
 *
 * ⚠️ `getLatestRiderStatus` is WEB's body. Mobile's additionally ignores a RiderAssignAttempt
 * entry whose note is not "Searching for rider"; web takes the last Rider* entry whatever its
 * note. Web is the reference (plan rule 3); flagged, not merged.
 */
import { PROCESSED } from "../../utils/constants/shared";
import { ASSIGN_NOTE, DAAS_CONSTANTS, SELF_DELIVERY } from "../../data/constants/shared";

export function isRiderAssignAttempted(orderData: any) {
  let { eventLog } = orderData ?? {},
    isRiderAttempted =
      eventLog?.length &&
      eventLog.some((obj: any) => obj.status === DAAS_CONSTANTS.RIDER_ATTEMPTED && obj.note === ASSIGN_NOTE);
  return !!isRiderAttempted;
}

/** Web-only in v1: a rider is assigned once `deliveryBy` carries a phone or a first name. */
export function isRiderAssigned(orderData: any) {
  return !!orderData?.deliveryBy?.contactInfo?.phoneNumber || !!orderData?.deliveryBy?.contactInfo?.name?.firstName;
}

export function getLatestRiderStatus(orderData: any) {
  let { eventLog = [] } = orderData ?? {};
  let lastStatusLog: any;
  for (let log of eventLog) {
    if (log.status?.includes("Rider")) {
      lastStatusLog = log;
    }
  }
  return lastStatusLog;
}

export function isRiderCancelled(orderData: any) {
  let { eventLog = [] } = orderData ?? {};
  return !!(eventLog?.length && eventLog.some((obj: any) => obj.status === DAAS_CONSTANTS.RIDER_CANCELLED));
}

export function isOrderDispatched(orderData: any) {
  return !!orderData?.eventLog?.some((e: any) => e?.status === DAAS_CONSTANTS.RIDER_DISPATCHED);
}

export const isSelfDeliveryOrder = (orderData: any) => !!orderData?.tags?.includes(SELF_DELIVERY);

/** The note the Processed event carries — "All items verified." or "2 items not verified." */
export const countUnverifiedItems = (orderInfo: any): string => {
  let note = "";
  orderInfo?.eventLog?.length > 0 &&
    orderInfo?.eventLog?.forEach((obj: any) => {
      if (obj?.status === PROCESSED) {
        note = obj?.note;
        return;
      }
    });
  return note;
};

export const isVerifiedStatus = (orderInfo: any) => orderInfo?.fulfillmentStatus === PROCESSED && !!countUnverifiedItems(orderInfo);
